import React from 'react'

// Services
import VendorServices from 'Services/Api/MasterData/vendor'
import GLAccountByTypesServices from 'Services/Api/GLAccounts/glAccounts'
import ProjectsServices from 'Services/Api/MasterData/project'
import AuthServices from 'Services/Api/Auth/Auth'
import GLAccountServices from 'Services/Api/MasterData/glAccount'
import AdvanceProjectClass from 'Services/Api/ProjectClass/projectClass'
import WTaxRateServices from 'Services/Api/MasterData/wTaxRate'
import ItemNumberServices from 'Services/Api/MasterData/itemNumber'

export default function OnClick(args) {
  const {
    name,
    isProjectClass = false,
    setSuggestions,
    params,
    wTaxCode,
    value,
    index
  } = args

  if (isProjectClass) {
    switch (name) {
      case 'glAccount':
        const parameter = value.projectClass[index].glCategory
        let _params = {
          ...params,
          sort: 1,
        }
        _params.search = parameter ? parameter : toString(parameter)
        GLAccountServices.getMany(_params).then(res => {
          const data = res.data.data
          const glAccounts = []
          data.map(items => {
            glAccounts.push(`${items.accountCode} ${items.accountName}`)
          })

          setSuggestions(glAccounts)
        })
        break
      case 'itemNumber':
        let _params3 = {
          ...params,
          sort: 1,
          search: String('')
        }
        ItemNumberServices.getMany(_params3).then(res => {
          const data = res.data.data
            
          const newData = []
          data.map(items => {
            newData.push(items.itemNo)
          })

          setSuggestions(newData)
        })
        break
      case 'projectClass':
        AdvanceProjectClass.getMany().then(res => {
          const data = res.data.data
          const newData = []
          data.map(items => {
            newData.push(items)
          })

          setSuggestions(newData)
        })
        break
      case 'wTaxType':
        const WtaxRate = []
        let _params2 = {
          ...params,
          sort: 1,
        }
        if (wTaxCode) {
          _params2.search = wTaxCode
          WTaxRateServices.getMany(_params2).then(response => {
            const data3 = response.data.data
            data3.map(items => {
              WtaxRate.push(!items.wTaxDisplayName ? 'X1 (None)' : `${items.wTaxCode} ${items.wTaxDisplayName}`)
            })
            setSuggestions([])
            setSuggestions(WtaxRate)
          })
        } else {
          setSuggestions(['X1 (None)'])
        }
        break
    }
  } else {
    switch (name) {
      case 'vendor':
        VendorServices.getMany(params).then(res => {
          const data = res.data.data
          const bpName = []
          const vatType = []
          data.map(items => {
            bpName.push(items.bpName)
            vatType.push(items.vatType)
          })
          setSuggestions(bpName)
        })
        break
      case 'department':
        AuthServices.getUser().then(res => {
          const data = res.data.data
          const department = []
          data.departments.map(items => {
            department.push(items.centerName)
          })
          setSuggestions(department)
        })
        break
      case 'project':
        ProjectsServices.getMany(params).then(res => {
          const data = res.data.data
          const project = []
          data.map(items => {
            project.push(items.projectName)
          })
          const index = project.indexOf('Megawide - Holding Company')
          alert(index)
          if (index > -1) project.splice(index, 1)
          const index2 = project.indexOf('Megawide - Main or Head Office')
          if (index2 > -1) project.splice(index2, 1)
          setSuggestions(project)
        })
        break
    }
  }
}
